import { useFirestore } from "../../../firebase/useFirestore";
import ToggleButton from "../../common/ToggleButton";

// Toggles the "Wervingsacties" menu link under Ondersteuning. Default on:
// when the CompagnyMeta field is unset we feed ToggleButton 'true' so the switch
// shows on and the first click writes 'false'. useSettings mirrors this default.
const WervingsactiesMenuToggle = () => {
    const compagny = useFirestore("CompagnyMeta");

    return (
        <div className="dashboard-container">
            <h2>Wervingsacties</h2>
            <p>
                Zet aan om de menu-link 'Wervingsacties' (deuracties) te tonen onder Ondersteuning. Standaard aan.
            </p>
            {compagny && compagny.map((comp) => (
                <div key={comp.ID} className="settings-general-module-settings-item-container">
                    <p>Wervingsacties tonen in menu</p>
                    <ToggleButton
                        docid={comp.docid}
                        id={"Wervingsacties"}
                        collection={"CompagnyMeta"}
                        value={comp.Wervingsacties === undefined ? 'true' : comp.Wervingsacties}
                    />
                </div>
            ))}
        </div>
    );
};

export default WervingsactiesMenuToggle;
